import { apiClient } from "lib/apiClient";
import {
  IResearchIntakeRequest,
  IResearchIntakeResponse,
} from "features/Research/types";

export const createResearchIntake = async (
  request: IResearchIntakeRequest
): Promise<IResearchIntakeResponse> => {
  const response = await apiClient.post("/research/intakes", request);
  return response.data;
};
